import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { shareReplay } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);

  langs = {};

  getTranslation(langPath: string) {
    if (!this.langs[langPath]) {
      this.langs[langPath] = this.http.get<Translation>(`/assets/i18n/${langPath}.json`).pipe(shareReplay());
    }
    return this.langs[langPath];
  }
}
